import React, { useState } from "react";
import { TextField, Card, CardContent } from "@mui/material";
import SriyanshCardHeader from "../../components/CardHeader";
import { useNavigate } from "react-router-dom";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import TokenService from "../../service/TokenService";
import EncryptService from "../../service/EncryptionService";
import apiClient from "../../BaseUrl/apiClient.js";
import useToast from "../../customHook/useToast";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
const ChangePasswordForm = () => {
  const tokenServiceDetails = TokenService.getUserDetails();
  const logineuname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  //const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});

  const { showToast, Toast } = useToast();

  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1);
  };

  const validate = () => {
    const errors = {};
    // if (!currentPassword) errors.currentPassword = 'Current password is required';
    if (!newPassword) errors.newPassword = "New password is required";
    if (newPassword !== confirmPassword)
      errors.confirmPassword = "Passwords do not match";
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      // Handle password change logic here

      apiClient
        .post("/changepassword", {
          uname: logineuname,
          pastext: confirmPassword,
          ipp: ip,
        })
        .then(function (response) {
          showToast("Your password is changed");
        })
        .catch(function (error) {
          setErrors(error.data);
        });

      // Clear form fields
      // setCurrentPassword('');

      setNewPassword("");
      setConfirmPassword("");
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div>
      {/* <SriyanshCardHeader Title="Change Your Password" /> */}
      {/* <div id="notification" class="notification hidden">Password changed successfully</div>
       */}
      <Toast />
      <Card className="Formcard">
      <div className="input-groupHeading">
      Change Your Password

            </div>


        <CardContent>
          <div className="row p-4" style={BoxStyle}>
            <div className="container">
              {/* <div className="input-group">
              <TextField
            fullWidth
            type="password"
            label="Current Password"
            variant="outlined"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            error={!!errors.currentPassword}
            helperText={errors.currentPassword}
          />
		  </div> */}

              <div className="input-group">
                <TextField
                  fullWidth
                  size="small"
                  type={showPassword ? "text" : "password"}
                  label="New Password"
                  variant="outlined"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  error={!!errors.newPassword}
                  helperText={errors.newPassword}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          edge="end"
                          aria-label="toggle password visibility"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              <div className="input-group">
                <TextField
                  fullWidth
                  type={showPassword ? "text" : "password"}
                  label="Confirm New Password"
                  variant="outlined"
                  size="small"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  error={!!errors.confirmPassword}
                  helperText={errors.confirmPassword}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          edge="end"
                          aria-label="toggle password visibility"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>

            <div
              className="flex container"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleSubmit}
                title="Click for Change Password"
              >
                Change Password
              </button>

              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Close"
                style={{ backgroundColor: "red", color: "white" }}
              >
                Close
              </button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ChangePasswordForm;
